import * as React from "react"
import { NavLink } from "react-router-dom"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Icon from "@bappweb/icon"
import Link from "@bappweb/link"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import LogoAkbank from "@components/globalmodules/logo"
import Events, { EVENT_TYPES } from "@utils/events"
import "./style.scss"

const Header = () => {
  
  const size = useDeviceSize()

  const handleMenuClick = React.useCallback(() => {
    Events.emit(EVENT_TYPES.menu, true)
  }, [])

  return (
    <Block type="header" className="bapp-header">
      <Block className="bapp-header-wrapper bapp-container">
        <Element className="bapp-header-logo">
          <NavLink to="/" className="bapp-link">
            <LogoAkbank />
          </NavLink>
        </Element>
        {size === Sizes.xs ? (
          <Link onClick={handleMenuClick}>
            <Icon name={Icon.Icons.NavigationMenu} />
          </Link>
        ) : (
          <>
            <Block type="nav" className="bapp-header-nav">
        
             
            </Block>
         
          </>
        )}
      </Block>
    </Block>
  )
}

export default Header
